/**
 * A release's status, as a pill.
 *
 * The labels, the colours, and the reasoning about what a status may and may not claim
 * live in lib/publisherStatus.ts — this file only draws the pill.
 */
import type { CSSProperties } from 'react';
import { PUBLISHER_STATUS_STYLES } from '../../lib/publisherStatus';
import { c } from '../../styles/theme';
import type { PublisherReleaseStatus } from '../../types/domain';

export interface ReleaseStatusBadgeProps {
  status: PublisherReleaseStatus;
  style?: CSSProperties;
}

export default function ReleaseStatusBadge({ status, style }: ReleaseStatusBadgeProps) {
  const { label, color, bg } = PUBLISHER_STATUS_STYLES[status];
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        fontSize: 10.5,
        letterSpacing: '0.04em',
        textTransform: 'uppercase',
        fontWeight: 600,
        color,
        background: bg,
        border: `1px solid ${c.border}`,
        borderRadius: 999,
        padding: '2px 9px',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {label}
    </span>
  );
}
